(function () {
  'use strict';

  var searchableFields = [
    'title',
    'product_type',
    'variants.title',
    'vendor',
    'variants.sku'
  ].join(',');

  function addSkuSearchField(inputUrl) {
    try {
      var url = new URL(inputUrl, window.location.origin);

      var isPredictiveSearch =
        url.pathname.endsWith('/search/suggest') ||
        url.pathname.endsWith('/search/suggest.json');

      if (!isPredictiveSearch) {
        return inputUrl;
      }

      url.searchParams.set(
        'resources[options][fields]',
        searchableFields
      );

      return url.toString();
    } catch (error) {
      return inputUrl;
    }
  }

  /*
   * Xtra teması arama isteğini fetch ile gönderiyorsa
   * isteğe SKU arama alanını otomatik ekler.
   */
  if (window.fetch) {
    var originalFetch = window.fetch;

    window.fetch = function (input, options) {
      try {
        if (input instanceof Request) {
          var modifiedRequestUrl = addSkuSearchField(input.url);

          if (modifiedRequestUrl !== input.url) {
            input = new Request(modifiedRequestUrl, input);
          }
        } else if (
          typeof input === 'string' ||
          input instanceof URL
        ) {
          input = addSkuSearchField(input.toString());
        }
      } catch (error) {
        console.error('Predictive SKU search error:', error);
      }

      return originalFetch.call(this, input, options);
    };
  }

  /*
   * Xtra teması XMLHttpRequest kullanıyorsa
   * aynı işlemi bu isteklerde de yapar.
   */
  if (window.XMLHttpRequest) {
    var originalXhrOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (
      method,
      url,
      async,
      username,
      password
    ) {
      var modifiedUrl = addSkuSearchField(url);

      return originalXhrOpen.call(
        this,
        method,
        modifiedUrl,
        async,
        username,
        password
      );
    };
  }
})();